import React from "react";
import { Input, type InputProps } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useControlledInputValue } from "./UseControlledInputValue";

interface StyledInputProps extends InputProps {
  icon?: React.ReactNode;
}

const StyledInput: React.FC<StyledInputProps> = ({
  className,
  icon,
  value,
  defaultValue,
  onChange,
  ...props
}) => {
  const controlled = useControlledInputValue(value, defaultValue, onChange);

  return (
    <Input
      {...props}
      value={controlled.value}
      onChange={controlled.onChange}
      prefix={icon ?? <SearchOutlined />}
      className={`styled-input ${controlled.hasValue ? "styled-input--has-value" : ""} ${
        className || ""
      }`}
    />
  );
};

export default StyledInput;
